import React from "react";
import { Tooltip } from "antd";
import { EyeOutlined, EditOutlined } from "@ant-design/icons";
import ButtonItem from "./ButtonItem";

const tooltipStyle = { fontSize: "10px", padding: "1px 5px", minHeight: "auto" };

/*
  Celda de acciones para los renglones de los reportes de contabilidad que
  corresponden a un movimiento de poliza.

  Reglas de edicion identicas a la lista de Polizas:
  (manual || editarTodasLasPolizas) && estado !== 0 && permiso.

  No esta conectado a Redux a proposito: se renderiza una vez por renglon y estos
  reportes pueden traer miles. El reporte que lo usa pasa las dos banderas.
*/
const AccionesPolizaReporte = ({
  polizaId,
  polizaManual,
  polizaEstado,
  permisoEditarPolizas,
  editarTodasLasPolizas,
  onVer,
  onEditar,
}) => {
  // Renglones sinteticos (encabezado de cuenta, saldo inicial, totales) no tienen poliza
  if (!polizaId) return null;

  const puedeEditar =
    (polizaManual || editarTodasLasPolizas) &&
    polizaEstado !== 0 &&
    permisoEditarPolizas;

  return (
    <div className="acciones-container">
      <Tooltip title="Ver Poliza" placement="top" overlayInnerStyle={tooltipStyle}>
        <ButtonItem
          type="default"
          size="small"
          azul
          icon={<EyeOutlined />}
          onClick={() => onVer(polizaId)}
        />
      </Tooltip>
      {puedeEditar && (
        <Tooltip title="Editar Poliza" placement="top" overlayInnerStyle={tooltipStyle}>
          <ButtonItem
            type="default"
            size="small"
            cyan
            icon={<EditOutlined />}
            onClick={() => onEditar(polizaId)}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default React.memo(AccionesPolizaReporte);
